module.exports = __webpack_public_path__ + "img/props.02199fb5.png";